import { Component } from '@angular/core';

@Component({
  selector: 'app-investment-licenses',
  templateUrl: './investment-licenses.component.html',
  styleUrl: './investment-licenses.component.scss'
})
export class InvestmentLicensesComponent {

}
